import { vocabulary } from '../data/vocabulary.js';
import { dueCards, rateCard, stats, getCard } from '../utils/srs.js';
import { AudioButton } from '../components/AudioButton.js';

let queue = [];
let flipped = false;

export function Flashcards(root) {
  queue = dueCards(vocabulary);
  flipped = false;
  render(root);
}

function render(root) {
  const s = stats(vocabulary);

  if (queue.length === 0) {
    root.innerHTML = `
      <header class="mb-8">
        <div class="text-[11px] uppercase tracking-[0.18em] text-moss-700 font-semibold">Flashcards</div>
        <h1 class="font-display text-3xl sm:text-4xl font-semibold text-slate2-900 mt-2">
          All caught up.
        </h1>
        <p class="mt-2 text-slate2-500">
          Your scheduled cards will be ready again when their box interval is up.
        </p>
      </header>
      <div class="card text-center py-14 max-w-xl mx-auto">
        <div class="text-5xl mb-4">🍂</div>
        <div class="text-slate2-700 font-medium">Nothing is due right now.</div>
        <div class="text-sm text-slate2-500 mt-1">
          Mastered ${s.mastered} of ${s.total} · learning ${s.learning}.
        </div>
        <div class="mt-6 flex justify-center gap-3 flex-wrap">
          <a href="/vocab" data-link class="btn-secondary">Browse vocabulary</a>
          <a href="/grammar/building-blocks" data-link class="btn-primary">Try the sentence builder</a>
        </div>
      </div>
    `;
    return;
  }

  const card = queue[0];
  const progress = getCard(card.id);

  root.innerHTML = `
    <header class="mb-8 flex flex-wrap items-start justify-between gap-4">
      <div>
        <div class="text-[11px] uppercase tracking-[0.18em] text-moss-700 font-semibold">Flashcards</div>
        <h1 class="font-display text-3xl sm:text-4xl font-semibold text-slate2-900 mt-2">
          Spaced repetition
        </h1>
        <p class="mt-2 text-slate2-500">
          ${queue.length} card${queue.length === 1 ? '' : 's'} due ·
          ${s.mastered}/${s.total} mastered ·
          ${s.learning} learning
        </p>
      </div>
      <div class="text-xs text-slate2-500">Box ${progress.box}/5 · seen ${progress.seen}×</div>
    </header>

    <div class="card mx-auto max-w-xl min-h-[300px] flex flex-col items-center
                justify-center text-center py-12 animate-slide-up
                ${flipped ? 'bg-sand-100/60' : ''}">
      ${flipped ? flippedFace(card) : frontFace(card)}
    </div>

    <div class="mt-6 max-w-xl mx-auto">
      ${flipped ? rateButtons() : `<button id="flip" class="btn-primary w-full">Show answer</button>`}
    </div>
  `;

  if (!flipped) {
    root.querySelector('#flip').addEventListener('click', () => {
      flipped = true;
      render(root);
    });
  } else {
    root.querySelectorAll('[data-rate]').forEach(btn => {
      btn.addEventListener('click', () => {
        rateCard(card.id, btn.getAttribute('data-rate'));
        queue.shift();
        flipped = false;
        render(root);
      });
    });
  }
}

function frontFace(card) {
  return `
    <div class="text-[11px] uppercase tracking-wider text-slate2-500 font-semibold mb-3">
      Norwegian
    </div>
    <div class="flex items-center gap-3">
      <div class="font-display text-4xl font-semibold text-slate2-900">${card.no}</div>
      ${AudioButton(card.no, { size: 'lg' })}
    </div>
    <div class="mt-6 text-sm text-slate2-500">Can you recall the English meaning?</div>
  `;
}

function flippedFace(card) {
  return `
    <div class="text-[11px] uppercase tracking-wider text-slate2-500 font-semibold mb-2">
      English
    </div>
    <div class="font-display text-3xl font-semibold text-slate2-900">${card.en}</div>
    <div class="text-sm text-slate2-500 italic mt-2">Literal: ${card.literal}</div>
    <div class="mt-6 flex items-center gap-3">
      <div class="font-display text-xl text-moss-700">${card.no}</div>
      ${AudioButton(card.no, { size: 'lg' })}
    </div>
  `;
}

function rateButtons() {
  return `
    <div class="grid grid-cols-3 gap-3">
      <button data-rate="again"
              class="btn bg-red-50 text-red-700 hover:bg-red-100
                     border border-red-200/60">
        <div class="flex flex-col items-center leading-tight">
          <span class="font-semibold">Again</span>
          <span class="text-[10px] opacity-70">reset to box 1</span>
        </div>
      </button>
      <button data-rate="good" class="btn-secondary">
        <div class="flex flex-col items-center leading-tight">
          <span class="font-semibold">Good</span>
          <span class="text-[10px] opacity-70">+1 box</span>
        </div>
      </button>
      <button data-rate="easy" class="btn-primary">
        <div class="flex flex-col items-center leading-tight">
          <span class="font-semibold">Easy</span>
          <span class="text-[10px] opacity-70">+2 boxes</span>
        </div>
      </button>
    </div>
  `;
}
